<script setup>
import { update_package, update_traits } from '@/services/option';
import { create_characteristics, update_characteristics, delete_characteristics } from '@/services/characteristics';
import { ref } from 'vue';
import { swalError, swalSuccess } from '@/helper';


const props = defineProps({
  data:{
    type: Object,
    require: true,
    default: {
      characters: [
        {
          id: 'talent',
          name: 'Talent',
          traits: [],
          tempTrait: ''
        },
        {
          id: 'iq',
          name: 'IQ',
          traits: [],
          tempTrait: ''
        },
        {
          id: 'eq',
          name: 'EQ',
          traits: [],
          tempTrait: ''
        },
        {
          id: 'personality',
          name: 'Personality',
          traits: [],
          tempTrait: ''
        },
        {
          name: 'Overall Wellness',
          traits: [],
          tempTrait: ''
        },
      ]
    }
  },
  package_id:{
    type: String,
    require: true,
  }
})

function addTraits(character){
  character.traits.push({name: character.tempTrait, id: ''})
  character.tempTrait = ''
}

function removeTrait(character, toRemove){
  if (toRemove.id == ''){
    character.traits = character.traits.filter((item) => item !== toRemove)
  }else{
    character.traits = character.traits.map(item =>{
      if (item === toRemove){
        item._destroy = 'true'
      }
      return item
    })
  }
}

const updating = ref(false)
async function saveOptionMeta(package_type){
  updating.value = true
  console.log(props.data)
  let response = await update_package(props.data.id, props.data.options)
  updating.value = false
  if (response.error){
    swalError(response.result.error, true)
  }else{
    swalSuccess('Change has been saved')
  }
}

async function saveTraits(){
  updating.value = true
  props.data.characters = await Promise.all(props.data.characters.map(async (item) => {
    const response = await update_traits(item.id, item)
    
    const { data, included } = response.result.data;
    const { id, attributes} = data;
    const { name } = attributes;
    const traits = included.map(trait => ({
      name: trait.attributes.name,
      id: trait.id
    }));

    // Construct the desired format
    const result = {
      id,
      name,
      traits
    };
    return result
  }))

  updating.value = false
  swalSuccess('Traits has been saved')
}

const editCharacter = ref({})
function editCharacterName(character){
  editCharacter.value = character
}

async function updateCharacter(){
  let response = await update_characteristics(editCharacter.value)
  if (response.error){
    Swal.fire({
      title: 'Error',
      text: 'Name could not be updated',
      icon: 'error'
    })
  }else{
    Swal.fire({
      title: 'Saved',
      text: 'Name has been saved',
      icon: 'success'
    })
    let ind = props.data.characters.findIndex(item => item.id == editCharacter.id)
    props.data.characters[ind] = editCharacter.value
    editCharacter.value = {}
  }
}

const showNewCharacter = ref(false)

const newName = ref('')
async function createCharacter(){
  let response = await create_characteristics({name: newName.value, option_id: props.package_id})
  if (!response.error){
    Swal.fire({
      title: 'Added',
      text: 'New category added',
      icon: 'success'
    })
    let temp = {
      name: response.result.data.data.attributes.name,
      id: response.result.data.data.id,
      traits: []
    }
    props.data.characters.push(temp)
    showNewCharacter.value = false
  }else{
    Swal.fire({
      title: 'Error',
      text: 'Error occur to add new catergory',
      icon: 'error'
    })
  }
}

async function removeCharacter(character){
  let response = await delete_characteristics(character)
  if (!response.error){
    Swal.fire({
      title: 'Deleted',
      text: 'Category has been deleted',
      icon: 'success'
    })
    let deleted = props.data.characters.findIndex(item => item.id == character.id)
    props.data.characters.splice(deleted, 1)
  }else{
    Swal.fire({
      title: 'Error',
      text: 'Error occur during deleting',
      icon: 'error'
    })
  }
}
</script>

<template>
  <div class="default-according mb-2" id="accordion">
    <div class="card">
      <div class="card-header" id="headingOne">
        <h5 class="mb-0">
          <button class="btn btn-link collapsed" 
            data-bs-toggle="collapse" 
            :data-bs-target="'#package_'+ package_id" 
            :aria-controls="'package_' + package_id"
          >
            {{ data.options.name?.value || 'Package Name' }}
          </button>
        </h5>
      </div>
      <div class="collapse" :id="'package_' + package_id" 
        aria-labelledby="headingOne" 
        data-bs-parent="#accordion"
      >
        <div class="card-body">
          <div class="row" v-auto-animate>
            <!-- Package Setting -->
            <div class="col-12">
              <div class="card-body">
                <div class="header-with-helper">
                  <h5>Package Setting</h5>
                  <div class="form-text">Edit general setting of a package</div>
                </div>
                <form @submit.prevent="saveOptionMeta(package_id)">
                  <div class="row mt-3">
                    <div class="col-md-6">
                      <label class="form-label">Package Name</label>
                      <input type="text" class="form-control" v-model="data.options.name.value">
                      <div class="form-text">
                        Package name in the parent view
                      </div>
                      
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-md-12">
                      <label class="form-label">Package Description</label>
                      <textarea rows="4" v-model="data.options.description.value"
                        placeholder="Package Description" 
                        class="form-control"
                        required
                      ></textarea>
                      <div class="form-text">
                        Short package description
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-md-6">
                      <label class="form-label">Min Value</label>
                      <input type="number" class="form-control" v-model="data.options.min.value">
                      <div class="form-text">
                        Minimum value required for the each traits
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label">Max Value</label>
                      <input type="number" class="form-control" v-model="data.options.max.value">
                      <div class="form-text">
                        Maximum value required for the each traits
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-md-6">
                      <label class="form-label">Default number of traits</label>
                      <input type="number" class="form-control" v-model="data.options.trait_val.value" placeholder="Number of trait">
                      <div class="form-text">
                        Number of trait can be selected by default user for assessment
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label">Trial Sample ID</label>
                      <input type="text" class="form-control" v-model="data.options.trial_id.value" placeholder="Trial ID">
                      <div class="form-text">
                        Free trial ID for Free Trial user
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label">Sample Text</label>
                      <input type="text" class="form-control" v-model="data.options.sample_text.value" placeholder="Trial ID">
                      <div class="form-text">
                        Sample text to be shown in parent view
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-4 offset-md-8">
                      <button class="float-end btn btn-success px-4" type="submit">
                        Save Setting
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <!-- Traits Setting -->
            <div class="col-md-6 py-2" v-for="character in data.characters">
              <div class="card-body border-top-1">
                <div class="flex-center justify-content-between">
                  <!-- Edit Character Info -->
                  <template v-if="editCharacter.id != character.id">
                    <div class="flex-center">
                      <h5 class="mb-0">{{ character.name }}</h5>
                      <button @click="editCharacterName(character)" class="btn icon-btn btn-light-warning ms-3">
                        <vue-feather type="edit-2" size="0.9rem" weight="2" />
                      </button>
                      <button @click="removeCharacter(character)" class="btn icon-btn btn-light-danger ms-2">
                        <vue-feather type="x" size="0.9rem" weight="2" />
                      </button>
                    </div>
                    <button class="float-end btn btn-light-success px-4" @click="saveTraits(package_id)">
                      <span v-if="updating">
                        <div class="spinner-border spinner-border-sm" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </span>
                      <span v-else>
                        Save Traits
                      </span>
                    </button>
                  </template>
                  <form v-else @submit.prevent="updateCharacter()" class="w-100 flex-center justify-content-start">
                    <input type="text" name="character_name" id="character_name" class="form-control" v-model="editCharacter.name">
                    <button type="submit" class="btn icon-btn btn-light-warning ms-3">
                      <vue-feather type="check" size="0.95rem" />
                    </button>
                  </form>
                </div>
                <form @submit.prevent="addTraits(character)">
                  <label class="form-label">Add Traits</label>
                  <div class="row">
                    <div class="col-md-8">
                      <input class="form-control" type="text" v-model="character.tempTrait">
                    </div>
                    <button class="col-md-4 btn btn-primary text-center" type="submit">
                      Add Trait
                    </button>
                  </div>
                </form>
                <div class="pt-2">
                  <p class="fw-4">List</p>
                  <div v-auto-animate>
                    <template v-for="(trait, index) in character.traits" 
                      :key="index" 
                    >
                      <div v-if="!trait._destroy"
                        class="row py-2 list-trait" 
                      >
                        <div class="col-md-10">
                          <p>
                            {{ trait.name }}
                          </p>
                        </div>
                        <div class="col-md-2">
                          <button 
                            @click="removeTrait(character, trait)"
                            class="btn remove-btn"
                          >
                            X
                          </button>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 py-2" v-auto-animate>
              <div v-if="showNewCharacter" class="card-body border-top-1">
                <!-- <div class="flex-center justify-content-start"> -->
                <form @submit.prevent="createCharacter" class="row align-items-center">
                  <div class="col-8">
                    <input type="text" placeholder="Enter character name" 
                      name="character_name" id="character_name" 
                      class="form-control" v-model="newName"
                      required
                    >
                  </div>
                  <div class="col-4 row">
                    <button type="submit" class="btn icon-btn btn-light-warning ms-3">
                      <vue-feather type="check" size="0.95rem" />
                    </button>
                    <button class="btn icon-btn btn-light-danger ms-1" type="button" @click="showNewCharacter = false">
                      <vue-feather type="x" size="0.95rem" />
                    </button>
                  </div>
                </form>
                <!-- </div> -->
                <form>
                  <label class="form-label">Add Traits</label>
                  <div class="row">
                    <div class="col-md-8">
                      <input class="form-control" type="text" disabled>
                    </div>
                    <button disabled class="col-md-4 btn btn-primary text-center" type="submit">Add Trait</button>
                  </div>
                </form>
                <div class="pt-2">
                  <p class="fw-4">List</p>
                  <div v-auto-animate>
                    <p>Traits Empty</p>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="card-body border-top-1">
                  <div class="flex-center">
                    <div>
                      <div class="mx-auto icon-btn btn-light-success mb-1 border-0">
                        <vue-feather type="plus" />
                      </div>
                      <button type="button" class="btn btn-light-success"
                        @click="showNewCharacter = true"
                      >
                        Add Category
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div> 

          <div class="row">
            <div class="offset-md-8 col-md-4">
              <button class="float-end btn btn-success px-4" @click="saveTraits(package_id)">
                <span v-if="updating">
                  <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </span>
                <span v-else>
                  Save Traits
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.border-top-1{
  border-top: 1px solid #ecf3fa !important;
  border-radius: 5px !important
}
</style>